<template>
  <div v-loading="loading" style="height: inherit">
    <div class="chart-bar">
      <div class="folat-right">
        <el-switch
          v-model="value1"
          active-text="显示数量"
          style="position: relative; top: -1px; margin-right: 15px"
          @change="lableShow"
        >
        </el-switch>
      </div>
      <div class="canvas" ref="canvas"></div>
    </div>

    <!-- <div class="no-data" v-else>暂无数据</div> -->
  </div>
</template>

<script>
import mixin from "@/views/preSalePlan/utils/mixin.js";
export default {
  mixins: [mixin],
  props: ["form", "radio"],
  data() {
    return {
      $instance: null,
      chartsData: {},
      loading: false,
      value1: false,
      mounthData: [],
      //预估总量
      estimateTotal: [],
      //有预有销实销量
      preOrSaleTotal: [],
      //共超卖
      oversoldTotal: [],
      //共积压
      backlogTotal: [],
      //达成率
      actPreSaleAttRate: [],
    };
  },
  computed: {},
  mounted() {
    this.init();
    // this.render();
  },
  methods: {
    lableShow() {
      this.render();
    },
    async init() {
      this.loading = true;
      let data = {
        planTime: this.form["planTime"],
        storeId: this.form["storeId"],
        type: this.radio == "日" ? 1 : this.radio == "月" ? 2 : 3,
      };

      this.$q.preSalePlan
        .analysisTrendChart({ data })
        .then((res) => {
          console.log(res);
          if (res.data) {
            let chartsData = res.data;
            this.chartsData = res.data;
            this.mounthData = chartsData.map((item) => item.month);
            this.estimateTotal = chartsData.map((item) => item.estimateTotal);
            this.preOrSaleTotal = chartsData.map((item) => item.preOrSaleTotal);
            this.oversoldTotal = chartsData.map((item) => item.oversoldTotal);
            this.backlogTotal = chartsData.map((item) => item.backlogTotal);
            this.actPreSaleAttRate = chartsData.map((item) =>
              item.actPreSaleAttRate.substring(
                0,
                item.actPreSaleAttRate.length - 1
              )
            );
            // console.log(this.mounthData);
            // console.log(this.estimateTotal);
            // console.log(this.preOrSaleTotal);
            // console.log(this.oversoldTotal);
            // console.log(this.backlogTotal);
            // console.log(this.actPreSaleAttRate);
            this.render();
          } else {
            this.$instance && this.$instance.clear();
          }
          this.loading = false;
        })
        .catch((_) => {
          this.$instance && this.$instance.clear();
          this.loading = false;
        });
    },
    render() {
      let $canvas = this.$refs["canvas"];

      let $instance = this.$instance;
      $instance && $instance.clear();
      $instance = this.$echarts.init($canvas);
      this.$instance = $instance;
      let option = {
        legend: {
          data: [
            "预估总量",
            "有预有销实销量",
            "共超卖",
            "共积压",
            "实际达成率",
          ],
          // selected: {
          //   '预估总量': true,
          //   '有预有销实销量': true,
          //   '共超卖': true,
          //   '共积压': true,
          //   '实际达成率': false,
          // },
          top: 50,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          confine: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          formatter: (params) => {
            let dayNum = [];
            let str = "";
            let arr = `${params[0].axisValue}<br/>`;
            params.forEach((p) => {
              str = `${p.marker}${
                p.seriesName
              } <span style="inline-block;text-algin:left; float:right; font-weight:800; margin-left: 30px;">${
                p.seriesName == "实际达成率" ? p.value + "%" : p.value || 0
              }</span><br/>`;
              dayNum.push(str);
            });
            dayNum.unshift(arr);
            return dayNum.join("");
            // }
          },
        },
        // dataset: {
        //     source: this.formatData
        // },
        grid: {
          left: 65,
          bottom: 20,
          right: 65,
          top: 120,
        },
        xAxis: {
          type: "category",
          data: this.mounthData,
          axisPointer: {
            type: "shadow",
          },
          axisTick: { show: false },
          // axisLabel: {
          //   color: 'rgb(135,139,160)',
          //   interval: 0,
          //   formatter: value =>{
          //     if(value.length > 4) {
          //       return String(value).substring(0,4)+'...'
          //     }else{
          //       return value+'月'
          //     }
          //   }
          // },
          axisLabel: {
            color: "rgb(135,139,160)",
            interval: 0,
            // rotate: data.length>12 ? 45 : 0
          },
          axisLine: {
            lineStyle: {
              color: "rgb(135,139,160)",
            },
          },
        },
        yAxis: [
          {
            name: "套数",
            type: "value",
            axisLabel: {
              color: "rgb(135,139,160)",
            },
            minInterval: 1,
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: "#e2e2e2",
              },
            },
            splitLine: { show: false },
          },
          {
            name: "达成率",
            type: "value",
            // min: 0,
            // max: Math.max(...this.actPreSaleAttRate.map((v) => v)),
            // interval: Math.ceil(
            //   Math.max(...this.actPreSaleAttRate.map((v) => v)) / 4
            // ),
            axisLabel: {
              show: true,
              color: "rgb(135,139,160)",
              interval: "auto",
              formatter: "{value} %", //纵坐标百分比
            },
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: "#e2e2e2",
              },
            },
            splitLine: { show: false },
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "预估总量",
            type: "bar",
            yAxisIndex: 0,
            data: this.estimateTotal.map((v) => {
              return v == 0 ? null : v;
            }),
            barMinHeight: 5,
            label: {
              show: true,
              position: "top",
            },
            select: {
              label: {
                show: true,
              },
              itemStyle: {
                color: "#ffffff",
                borderColor: "#00A6ED",
                borderWidth: 0,
              },
            },
          },
          {
            name: "有预有销实销量",
            type: "bar",
            yAxisIndex: 0,
            data: this.preOrSaleTotal.map((v) => {
              return v == 0 ? null : v;
            }),
            barMinHeight: 5,
            label: {
              show: true,
              position: "top",
            },
            select: {
              label: {
                show: true,
              },
              itemStyle: {
                color: "#ffffff",
                borderColor: "#00A6ED",
                borderWidth: 0,
              },
            },
          },
          {
            name: "共超卖",
            type: "bar",
            yAxisIndex: 0,
            data: this.oversoldTotal.map((v) => {
              return v == 0 ? null : v;
            }),
            barMinHeight: 5,
            label: {
              show: true,
              position: "top",
            },
            select: {
              label: {
                show: true,
              },
              itemStyle: {
                color: "#ffffff",
                borderColor: "#00A6ED",
                borderWidth: 0,
              },
            },
          },
          {
            name: "共积压",
            type: "bar",
            yAxisIndex: 0,
            data: this.backlogTotal.map((v) => {
              return v == 0 ? null : v;
            }),
            barMinHeight: 5,
            label: {
              show: true,
              position: "top",
            },
            select: {
              label: {
                show: true,
              },
              itemStyle: {
                color: "#ffffff",
                borderColor: "#00A6ED",
                borderWidth: 0,
              },
            },
          },
          {
            name: "实际达成率",
            type: "line",
            yAxisIndex: 1,
            data: this.actPreSaleAttRate,
            label: {
              show: true,
              formatter: function (params) {
                  if (params.value) {
                    return params.value + "%";
                  } else {
                    //否则返回个空
                    return "";
                  }
                },
              position: "top",
            },
            select: {
              label: {
                show: true,
              },
              itemStyle: {
                color: "#ffffff",
                borderColor: "#00A6ED",
                borderWidth: 0,
              },
            },
          },
        ],
      };
      console.log(option);
      if (this.value1) {
        option.series.forEach((item) => {
          item.label.show = true;
        });
      } else {
        option.series.forEach((item) => {
          item.label.show = false;
        });
      }
      $instance.setOption(option);
      // $instance.on("legendselectchanged", function (obj) {
      //   console.log(option);
      //   console.log(option);
      //   if (
      //     !obj.selected["预估总量"] &&
      //     !obj.selected["有预有销实销量"] &&
      //     !obj.selected["共超卖"] &&
      //     !obj.selected["共积压"]
      //   ) {
      //     option.yAxis.name = "达成率";
      //     option.yAxis.axisLabel = {
      //       show: true,
      //       color: "rgb(135,139,160)",
      //       interval: "auto",
      //       formatter: "{value} %", //纵坐标百分比
      //     };
      //   } else {
      //     option.yAxis.name = "套数";
      //     option.yAxis.axisLabel = {
      //       show: true,
      //       color: "rgb(135,139,160)",
      //       interval: "auto",
      //       formatter: "{value} ", //纵坐标百分比
      //     };
      //     // option.yAxis[0].max = Math.max(...chartsData.map(v=>v.avgBuyNum))
      //     // option.yAxis[0].interval = Math.ceil(Math.max(...data.map(v=>v.avgBuyNum)) / 4)
      //   }
      //   $instance.setOption(option);
      // });
      // $instance.dispatchAction({
      //   type: 'legendInverseSelect'
      // });
      // $instance.dispatchAction({
      //   type: 'legendSelect',
      //   name: '产品'
      // });
    },
  },
};
</script>

<style lang="stylus" scoped>
.canvas {
  width: 100%;
  height: 40vh;
  background: #ffffff;
}

.chart-bar {
  position: relative;
}

.folat-right {
  position: absolute;
  top: 20px;
  right: 50px;
  z-index: 5;
}
</style>